import React, { useState, useEffect } from "react";
import "./Home.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import Fade from "react-reveal/Fade";

import img1 from "./assets/7.png";
import img2 from "./assets/8.png";
import img3 from "./assets/2.png";
import img4 from "./assets/6.png";

export const Home = () => {
  const services = [
    "בניית אתרים",
    "פרסום באינטרנט",
    "קידום ברשתות חברתיות",
    "קידום גוגל",
    "קידום אורגני",
    "שיווק דיגיטלי",
    "מיתוג",
  ];

  const cards = [
    {
      img: img1,
      title: "למה להקים אתר אינטרנט ?",
      text:
        " רוב האנשים שצריכים שירות מקצועי או מחפשים לקנות מוצר כלשהו, רובם פונים קודם כל למנועי גוגל - חיפוש ברשת ! מי שלא נמצא בעולם הדיגטלי כאילו לא קיים וגם הלקוחות מחפשים מידע עליך. הם מחפשים כל הזמן, גם כשאינך מודע לכך. החיפוש חייב להותיר רושם חיובי. הלקוחות מחפשים חיזוק לכך שיש על מי לסמוך והיום כולם בודקים את זה באמצעות האינטרנט.",
    },
    {
      img: img2,
      title: "במה זה עוזר לי ? ",
      text:
        " הלקוחות מחפשים חיזוק לכך שיש על מי לסמוך, שהאדם / חברה / ארגון שעומד מנגד מייצג משהו מסודר ואמין. אתר תדמית לעסק בהחלט משרת את המטרה הזו, בעיני הלקוח המודרני הדבר מקנה תחושת רצינות וביסוס של העסק, ושלילת האפשרות שמדובר במשהו חובבני וארעי.חשבו על השחקנים הגדולים בכל תחום שבו אתם הלקוחות. האם הייתם עובדים איתם כאשר הייתם מחפשים את שם החברה ברשת ומוצאים לא יותר מעמוד פייסבוק? לכן אתר תדמית לעסק הוא חובה.",
    },
    {
      img: img4,
      title: "איזה סוג אתר עדיף ?",
      text:
        "   קיימים כמה סוגי אתרים : אתרי תדמית - לרוב מדובר בדף נחיתה (עמוד אחד עם תבנית בסיסת ), והוא הזול ביותר, ולפעמים עוד כמה עמודים ייצוגים המציגים את העסק והשירותים שלו, בית עסק שמעוניין רק לפרסם את עצמו ושירותיו , זה סוג האתר שמתאים לו  . אתרי חנות - אלו כבר אתרים שמעונינים למכור מוצרים ולבצע משלוחים ולכן צריך באתר אבטחה גבוהה, סליקה, שרת יציב ועוד .  קיימים עוד סוגים אבל אלה העיקרים בשוק בעלי העסקים והפרטיים.",
    },
    {
      img: img3,
      title: "כמה זה עולה ?",
      text:
        "  כמה עולה לבנות אתר אינטרנט ? מחוסר ידע לגבי מחיר בניית אתר קורה לא אחת שבעלי עסקים מגיעים עם תקציב מסוים ומגלים שהם צריכים בכלל לשלם תקציב אחר לגמרי , ברוב המקרים יותר גבוה. ואז מתחיל שלב המשא ומתן המעייף על מחיר בניית אתר ובתי העסק נמצאים בנחיתות משמעותית בגלל שאינם מבינם בתחום כלל . בשביל לעלות את הסכום יכניסו כל מיני רכיבים , אלמנטורים וכו' שאולי בית העסק בכלל לא צריך . ונוסף על כך בעלי העסקים אינם מבינים שכאשר מורידים את המחיר לאתר , האתר שלכם יהיה פשוט וסביר להניח עשוי דרך כל מיני דרכים שיקצרו את התהליך של בניית האתר ומה שיקרה מכך תקבלו אתר איטי מאוד , פחות מהירות וכו",
    },
  ];

  // ===== טייפינג אינסופי =====
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = services[index % services.length];

    const speed = deleting ? 60 : 120;

    const timer = setTimeout(() => {
      if (!deleting) {
        setText(current.substring(0, text.length + 1));

        if (text === current) {
          setTimeout(() => setDeleting(true), 1000);
        }
      } else {
        setText(current.substring(0, text.length - 1));

        if (text === "") {
          setDeleting(false);
          setIndex((prev) => prev + 1);
        }
      }
    }, speed);

    return () => clearTimeout(timer);
  }, [text, deleting, index]);

  return (
    <div className="home-wrapper">

      {/* טייפינג */}
      <h4 className="ppp">מה אנחנו עושים :</h4>

      <div className="typing-box">
        {text}
        <span className="cursor">|</span>
      </div>
<div className="info-list">
  {cards.map((card, i) => (
    <Fade bottom key={i}><div className="info-row">

  {/* תמונה קודם */}
  <div className="info-img">
    <img src={card.img} alt={card.title} />
  </div>

  {/* טקסט אחר כך */}
  <div className="info-text">
    <h3>{card.title}</h3>
    <p>{card.text}</p>
  </div>

</div>
    </Fade>
  ))}
</div>

    </div>
  );
};